import { useState, useEffect } from 'react';
import { VendorHeader } from './VendorHeader';
import { VendorSidebar } from './VendorSidebar';
import  Dashboard  from './Dashboard';
import { PropertyForm } from './propertyForm';
import { MyProperties } from './MyProperties';
import { PaymentDetails } from './PaymentDetails';
import { PropertyDetailPage } from './PropertyDetailsPage';
import { PropertyEditPage } from './PropertyEditPage';
import { PasswordReset } from './PasswordReset';
import VendorBookingsCalendar from './VendorBookingsCalendar';
import HelpSupport from './ContactSupport';
import { toast } from "react-toastify";
import axios from 'axios';
import { KeyUri } from '../key';

const vendorToken = localStorage.getItem('vendorToken')
export default function IndexVendor() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [mobileOpen, setMobileOpen] = useState(false);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

const [showPropertyDetail, setShowPropertyDetail] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

const [showPropertyEdit, setShowPropertyEdit] = useState(false);
const [editPropertyId, setEditPropertyId] = useState(null);
  const [vendorStatus, setVendorStatus] = useState('active'); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVendorStatus = async () => {
      try {
        const token = localStorage.getItem('vendorToken');
        if (!token) return;

        const res = await axios.get(`${KeyUri.BACKEND_URI}/vendor/profile`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const vendor = res.data.vendor;
        setVendorStatus(vendor.status || 'active');
      } catch (err) {
        console.error('Error fetching vendor status', err);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorStatus();
  }, []);

const renderVendorContent = () => {
  if (loading) return <p>Loading...</p>;

    if (vendorStatus === 'suspended') {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] py-12 px-4 bg-red-50 border border-red-200 rounded-xl max-w-2xl mx-auto">
        <div className="text-center">
          <div className="w-24 h-24 mx-auto mb-8 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 0l-6.849 6.848m0 0l-6.849-6.848m6.849 6.848V20m0 0v-4m0-4H12" />
            </svg>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-red-800 mb-4">
            Account Suspended
          </h2>
          
          <p className="text-lg text-red-700 mb-8 max-w-md leading-relaxed">
            Your vendor account has been suspended. Please contact support to resolve this issue.
          </p>
          
          <button
            onClick={() => {
              localStorage.removeItem('vendorToken');
              window.location.href = '/vendor/login';
            }}
            className="px-8 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Logout & Return to Login
          </button>
        </div>
      </div>
    );
  }

 
  if (showPropertyDetail && selectedProperty) {
    return (
      <PropertyDetailPage
        property={selectedProperty}
        onBack={() => {
          setShowPropertyDetail(false);
          setSelectedProperty(null);
        }}
        onBookNow={() => toast.success('Booking functionality coming soon!')}
      />
    );
  }

  if (showPropertyEdit && editPropertyId) {
    return (
      <PropertyEditPage
        propertyId={editPropertyId}
        onBack={() => {
          setShowPropertyEdit(false);
          setEditPropertyId(null);
        }}
      />
    );
  }

  switch (activeTab) {
    case 'dashboard':
      return <Dashboard setActiveTab={setActiveTab} />;
    case 'add-property':
      return (
        <div>
          <div className="mb-6 mt-6 md:mt-0">
            <h2 className="text-2xl text-gray-900">Add New Property</h2>
            <p className="text-gray-600 mt-1">Fill in the details to list your property</p>
          </div>
          <PropertyForm />
        </div>
      );
    case 'my-properties':
      return (
      <MyProperties
  onPropertySelect={(property) => {
    if (vendorStatus === 'suspended') {
      toast.error('Your account is suspended. Cannot view property.');
      return;
    }
    setSelectedProperty(property);
    setShowPropertyDetail(true);
  }}
  onPropertyEdit={(propertyId) => {
    if (vendorStatus === 'suspended') {
      toast.error('Your account is suspended. Cannot edit property.');
      return;
    }
    setEditPropertyId(propertyId);
    setShowPropertyEdit(true);
  }}
/>

      );
    case 'bookings-calendar':
      return <VendorBookingsCalendar />;
    case 'analytics':
      return (
        <div className="text-center py-20">
          <h2 className="text-2xl text-gray-900 mb-2">Analytics</h2>
          <p className="text-gray-600">Analytics dashboard coming soon...</p>
        </div>
      );
    case 'payments':
      return <PaymentDetails />;
    case 'security':
      return <PasswordReset />;
    case 'settings':
      return (
        <div className="text-center py-20">
          <h2 className="text-2xl text-gray-900 mb-2">Settings</h2>
          <p className="text-gray-600">Settings page coming soon...</p>
        </div>
      );
    case 'help':
      return <HelpSupport/>
    default:
      return <Dashboard setActiveTab={safeSetActiveTab} />;
  }
};

const safeSetActiveTab = (tab) => {
  if (vendorStatus === 'suspended') {
    toast.error('Your account is suspended. Navigation is blocked.');
    return;
  }
  setActiveTab(tab);
};

 return (
  <div className="min-h-screen bg-gray-50 relative">
    {/* Fixed header at top */}
    <div className="fixed top-0 left-0 w-full z-20">
      <VendorHeader onMenuClick={() => setMobileOpen(true)} />
    </div>
    {/* Sidebar fixed at left, below header */}
   <div className="flex pt-16">
      {/* desktop sidebar */}
      <div className="hidden md:block fixed top-16 left-0 h-[calc(100vh-4rem)] w-64 z-10 bg-white border-r">
     <VendorSidebar
  activeTab={activeTab}
  onTabChange={safeSetActiveTab} 
  variant="desktop"
  disabled={vendorStatus === 'suspended'}
/>
      </div>

<VendorSidebar
  activeTab={activeTab}
  onTabChange={safeSetActiveTab}
  variant="mobile"
  mobileOpen={mobileOpen}
  onMobileClose={() => setMobileOpen(false)}
  disabled={vendorStatus === 'suspended'}
/>

      <main className="flex-1 w-full md:ml-64 p-4 md:p-8">
        <div className="max-w-7xl mx-auto">{renderVendorContent()}</div>
      </main>
    </div>
    {/* Toast notifications (correct usage) */}
    {/* <ToastContainer position="top-right" /> */}
  </div>
);

}
